// frontend/shared-ui/src/hooks/usePersistedState.js
import { useState, useCallback } from 'react';

/**
 * useState that persists to localStorage.
 * Automatically handles JSON serialization/deserialization and errors.
 */
export function usePersistedState(key, initialValue) {
    const [state, setState] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            if (raw === null) return initialValue;
            return JSON.parse(raw);
        } catch {
            return initialValue;
        }
    });

    const set = useCallback(
        (value) => {
            const next = typeof value === 'function' ? value(state) : value;
            try {
                localStorage.setItem(key, JSON.stringify(next));
            } catch { }
            setState(next);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [key]
    );

    return [state, set];
}